export default __webpack_public_path__ + "static/media/down-arrow.ac1477e7.svg";